import { TextSize } from "../../../Text/Text.types.js";
import { ProgressTextProps } from "./types.js";

export const DONE_TEXT_SIZE_MAP: Record<ProgressTextProps["size"], TextSize> = {
    small: TextSize["XX-SMALL"],
    medium: TextSize.MEDIUM,
    large: TextSize.SMALL,
};

export const PROGRESS_TEXT_SIZE_MAP: Record<ProgressTextProps["size"], TextSize> = {
    small: TextSize["X-SMALL"],
    medium: TextSize.MEDIUM,
    large: TextSize.LARGE,
};
